// eslint-disable-next-line import/extensions
import { useVyNavigate } from '../../../hooks/use-vy-navigate';
import { ArrowIcon } from '../../icons/ArrowIcon';
import { ARROW_ICON_DIRECTIONS } from '../../icons/ArrowIcon/types/arrow-icon-direction';

type BackButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export const BackButton: React.FC<BackButtonProps> = (props) => {
  const navigate = useVyNavigate();

  return (
    <button
      className='flex items-center space-x-3'
      onClick={() => navigate(-1)}
      {...props}
    >
      <ArrowIcon
        className='text-style'
        direction={ARROW_ICON_DIRECTIONS.LEFT}
      />
      <p className="text-placeholder text-[15px]">Back</p>
    </button>
  );
};